import { ORG_REDUCER } from "../constants/enums";
import {
  createBusinessUnitService,
  industriesService,
  updateBusinessUnitService,
} from "../services/orgService";

const checkDataUpdateStatus = (data: any, initialData: any) => {
  const infoUpdated =
    data.businessUnit.name !== initialData.businessUnit.name ||
    data.businessUnit.type !== initialData.businessUnit.type ||
    data.businessUnit.industry !== initialData.businessUnit.industry ||
    data.businessUnit.country !== initialData.businessUnit.country ||
    data.businessUnit.timeZone !== initialData.businessUnit.timezone ||
    data.businessUnit.dialCode !== initialData.businessUnit.dialcode ||
    data.businessUnit.mobile !== initialData.businessUnit.mobile ||
    data.businessUnit.email !== initialData.businessUnit.email ||
    data.businessUnit.address?.addressLine1 !==
      initialData.businessUnit.address?.addressLine1;
  const preferencesUpdated =
    data.preference.currency !== initialData.businessUnitPreferences.currency ||
    data.preference.carbonPrice !==
      initialData.businessUnitPreferences.carbonPrice ||
    data.preference.directEmissionApproval !==
      initialData.businessUnitPreferences.directEmissionApproval ||
    data.deleteCategories?.length ||
    data.categoryPreferences?.length;
  data["infoUpdated"] = !!infoUpdated;
  data["preferencesUpdated"] = !!preferencesUpdated;
};

export const fetchIndustryData = () => {
  return industriesService();
};
export const createOrUpdateBusinessUnitAction = (
  data: any,
  initialData: any
) => {
  const registerUserNameObject: any = data;

  if (data.businessUnit?.id) {
    initialData && checkDataUpdateStatus(data, initialData);
    return updateBusinessUnitService(registerUserNameObject);
  } else {
    const company = JSON.parse(localStorage.getItem("company") || "").id;
    registerUserNameObject.company = company;
    return createBusinessUnitService(registerUserNameObject);
  }
};
export const setCategoryPreferences = (data: any): any => ({
  type: ORG_REDUCER.SET_CATEGORY_PREFERENCES,
  payload: data,
});
